'use client';

import { useParams } from 'next/navigation';
import { useSuspenseQuery } from '@apollo/client/react';
import LoginRequired from '@/components/login-required';
import { groupGalleryQuery } from '@/apollo/groups';
import GroupImageUploads from '@/components/groups/image-uploads';

const GroupPhotosPageClient = () => {
  const { slug } = useParams();

  const { data } = useSuspenseQuery(groupGalleryQuery, {
    variables: { slug },
  });
  const group = data?.group;

  if (!group.permissions.accessible) {
    return <LoginRequired />;
  }

  return (
    <GroupImageUploads group={group} />
  );
};

export default GroupPhotosPageClient;
